import { useState } from 'react';
export var useTimeMeasurement = function (_a) {
    var handleRowClick = _a.handleRowClick;
    var _b = useState(0), startTime = _b[0], setStartTime = _b[1];
    var handleMouseDown = function () {
        // Set the start time when mouse is pressed
        var start = Date.now();
        setStartTime(start);
    };
    var handleMouseUp = function (e) {
        if (startTime !== 0) {
            // Calculate the time difference between mouse down and up
            var endTime = Date.now();
            var duration = endTime - startTime;
            if (duration > 0 && duration < 200) {
                handleRowClick(e);
            }
            setStartTime(0);
        }
    };
    return { handleMouseDown: handleMouseDown, handleMouseUp: handleMouseUp };
};
